import * as actionTypes from './actiontypes';
import * as API from './api';
import { startPageLoading, stopPageLoading } from '../page_details/actions';
import { updateCustumAgentNoteForm, getCurrentChatHistory } from '../history_details/api';
import { log } from '../../config/utils'

export const updateChatsState = payload => {
  return {
    type: actionTypes.UPDATE_CHATS_STATE,
    payload
  };
}

export const updateChatStateValue = (payload, path) => {
  return {
    type: actionTypes.UPDATE_CHAT_STATE_VALUE,
    payload,
    path
  };
}

export const makeChatsSocketConnection = (host, ip) => {
  return {
    type: actionTypes.CHATS_MAKE_SOCKET_CONNECTION,
    host,
    ip
  };
}

export const chatsSocketDisconnect = () => {
  return {
    type: actionTypes.CHATS_SOCKET_DISCONNECT,
  };
}

export const callChatsSocketMethod = payload => {
  return {
    type: actionTypes.CALL_CHATS_SOCKET_METHOD,
    payload
  }
}

export const emitChatsCustomEvent = (event, payload, callback) => {
  return {
    type: actionTypes.EMIT_CHATS_CUSTOM_EVENT,
    payload,
    event,
    callback
  };
}

export const joinChatsPage = () => {
  return {
    type: actionTypes.JOIN_CHATS_PAGE,
    payload: {}
  };
}

export const closeChatInterface = () => {
  return {
    type: actionTypes.CLOSE_CHAT_INTERFACE,
  };
}

export const updateChatItem = payload => {
  return {
    type: actionTypes.CHATS_UPDATION,
    payload
  }
}

export const deleteChatItem = (payload, reason) => {
  return {
    type: actionTypes.CHATS_DELETION,
    payload,
    reason
  }
}

export const emitMessageSeen = () => {
  return {
    type: actionTypes.EMIT_MESSAGE_SEEN,
  };
}

export const getTagsByGroup = payload => {
  return dispatch => {
    dispatch(updateChatStateValue(true, 'loaders.tags_loading'));
    API.getTagsByGroup(payload, (error, response) => {
      log('getTagsByGroup', response)
      if (!error && response && response.data && response.data.psid && response.data.tagsList) {
        dispatch({
          type: actionTypes.GROUP_TAGS_LOADED,
          payload: response.data,
        });
      }
      dispatch(updateChatStateValue(false, 'loaders.tags_loading'));
    });
  };
}

export const addSelectedTag = payload => {
  return {
    type: actionTypes.ADD_SELECTED_TAG,
    payload
  }
}

export const removeSelectedTag = payload => {
  return {
    type: actionTypes.REMOVE_SELECTED_TAG,
    payload
  }
}

export const updateCustumAgentNoteFormInChats = (payload, data, callback) => {
  return dispatch => {
    dispatch(startPageLoading("updating"));
    updateCustumAgentNoteForm(payload, (error, response) => {
      dispatch(stopPageLoading());
      if (!error && response) {
        if (callback) callback();
        dispatch({
          type: actionTypes.UPDATE_CHAT_PROFILE,
          payload: data
        });
      }
    });
  };
}

export const joinChatItemByPsid = (psid, admin_id) => {
  return {
    type: actionTypes.JOIN_CHAT_ITEM_BY_PSID,
    payload: psid,
    admin_id
  }
}

export const chatItemClicked = (payload, admin_id) => {
  return {
    type: actionTypes.CHAT_ITEM_CLICKED,
    payload,
    admin_id
  }
}

export const switchAlreadyJoinedChat = payload => {
  return {
    type: actionTypes.SWITCH_ALREADY_JOINED_CHAT,
    payload
  }
}

export const joinChatRoom = payload => {
  return {
    type: actionTypes.JOIN_CHAT_ROOM,
    payload
  }
}

export const chatRoomJoined = (payload, psid) => {
  return {
    type: actionTypes.CHAT_ROOM_JOINED,
    payload,
    psid
  };
}

export const getJoinedRoomUserProfile = payload => {
  return dispatch => {
    dispatch(updateChatStateValue(true, 'loaders.customer_profile_loading'))
    API.getJoinedRoomUserProfile(payload, (err, res) => {
      dispatch(updateChatStateValue(false, 'loaders.customer_profile_loading'))
      if (!err && res && res.data && res.data.changedUserProfileDetails && res.data.changedUserProfileDetails.psid && res.data.changedUserProfileDetails.userProfileDetails)
        dispatch({
          type: actionTypes.JOINED_ROOM_USER_PROFILE_RECEIVED,
          payload: res.data.changedUserProfileDetails
        })
    });
  };
}

export const getUntaggedChatlogs = data => dispatch => {
  dispatch(startPageLoading("loading"));
  getCurrentChatHistory({ sessionId: data.sessionId }, (error, response) => {
    log('getUntaggedChatlogs  response', response);
    dispatch(stopPageLoading());
    if (!error && response && response.sessionId && response.chatLogs && response.userProfileDetails) {
      dispatch({
        type: actionTypes.UNTAGGED_CHATLOG_RECEIVED,
        payload: response,
        id: data.id
      })
    }
  })
}


// WEBPACK FOOTER //
// ./src/data/redux/chats_details/actions.js